export default "__VITE_ASSET__c6c450ce__"